import { Partner } from './partner/partner';
import { Currency } from './currency';
import { Chat } from './chat';

export interface SaleOrder {
  id: number;
  name: string;
  budgetCode: string;
  driveUrl?: string | null;
  dateCancelled?: string | null;
  dateApproved?: string | null;
  dateConfirm?: string | null;
  expirationDate?: string;
  stage: string;
  isActive: boolean;
  budgetAdopted: boolean;
  dateBudgetAdopted?: string | null;
  leadId: number;
  /** Compañía de la cotización: la API la devuelve siempre (CEC-689 la usa para filtrar impuestos). */
  companyId?: number | null;
  lead?: {
    id: number;
    name: string;
    type: string;
    opportunityType?: string;
    priority?: string;
    expectedRevenue?: {
      source: string;
      parsedValue: number;
    };
  };
  teamId?: number;
  team?: {
    id: number;
    name: string;
    color?: string | null;
  };
  currencyId: number;
  currency?: Currency;
  partnerId: number;
  partner?: Partner;
  chatId: number;
  chat?: Chat;
  createdOn?: string;
  modifiedOn?: string;
}


export interface AdoptBudgetResult {
  saleOrder?: SaleOrder | null;
  requiresConfirmation: boolean;
  modifiedLinkedLinesCount: number;
  affectedBudgetLineIds: number[];
}
